import { render, staticRenderFns } from "./InvalidIndicator.vue?vue&type=template&id=45482a70&scoped=true&"
import script from "./InvalidIndicator.vue?vue&type=script&lang=js&"
export * from "./InvalidIndicator.vue?vue&type=script&lang=js&"
import style0 from "./InvalidIndicator.vue?vue&type=style&index=0&id=45482a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45482a70",
  null
  
)

export default component.exports